import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ExchangeStatus } from '@/modules/transaction/services/exchange';

interface ContentData {
  icon: {
    name: string;
    mainColor: NebraskaColors;
    textColor: NebraskaColors;
  };
  title: string;
  description: string;
  labels: {
    netValue: string;
    tradedValue: string;
  };
}

type StatusBasedContent = {
  [key in ExchangeStatus]: ContentData;
};

const STATUS_CONTENT: StatusBasedContent = {
  scheduled: {
    icon: {
      name: 'ic_progress_clock',
      mainColor: NebraskaColors.statusInfoBackground,
      textColor: NebraskaColors.statusInfo
    },
    title: 'Transferência solicitada',
    description: 'O valor estará disponível em até 1 dia útil',
    labels: {
      netValue: 'Valor que sairá de sua conta',
      tradedValue: 'Valor que será enviado'
    }
  },
  completed: {
    icon: {
      name: 'ic_check_simple',
      mainColor: NebraskaColors.statusPositiveBackground,
      textColor: NebraskaColors.elementPrimary
    },
    title: 'Transferência concluída',
    description: 'O valor enviado já está disponível na conta favorecida',
    labels: {
      netValue: 'Valor que saiu de sua conta',
      tradedValue: 'Valor enviado'
    }
  }
};

export default STATUS_CONTENT;
export type { ContentData };
